import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromStrideReview from './reducers/stride-review-reducer';
import { EffectsModule } from '@ngrx/effects';
import { StrideReviewEffects } from './effects/stride-review.effects';
import { StrideReviewService } from './services/stride-review.service';
import { StrideReviewFacade } from './facades/stride-review.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromStrideReview.STRIDE_REVIEW_KEY,
      fromStrideReview.reducer
    ),
    EffectsModule.forFeature([StrideReviewEffects]),
  ],
  providers: [StrideReviewService, StrideReviewFacade],
})
export class StrideReviewStoreModule {}
